// TODO: remove inline styling from this file!

import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Tag } from 'components/ui/Tag';
import { Button } from 'components/ui/Button';

import { Bumper, Card, HorizontalFlexWrapper } from 'styles/shared';
import { Fonts, spacing, transparencies } from 'styles/theme';
import { CloseButtonWrapper } from 'styles/modal';

interface ProfileCardProps {
    profileId: string;
    fullName: string;
    imageUrl?: string;
    headline: string;
    isCoach: boolean;
    isHq: boolean;
    isPublished: boolean;
}

export const ProfileCard = ({
    profileId,
    fullName,
    imageUrl,
    headline,
    isCoach,
    isHq,
    isPublished,
}: ProfileCardProps) => {
    const [, setSearchParams] = useSearchParams();

    const onOpenProfileDetails = useCallback(() => {
        setSearchParams({
            modalContent: 'profile',
            profileId: profileId,
        });
    }, [profileId, setSearchParams]);

    return (
        <Card
            $width="280px"
            $mobileWidth="100%"
            $padding={spacing.large}
            $backgroundColor={transparencies.white10}
            style={
                !isPublished || imageUrl == null || imageUrl === ''
                    ? { minHeight: '160px' }
                    : {
                          minHeight: '160px',
                          backgroundImage: `url(${imageUrl})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center center',
                          border: 'none',
                      }
            }
        >
            {!isPublished || imageUrl == null || imageUrl === '' ? null : (
                <div
                    style={{
                        borderRadius: '16px',
                        border: `1px solid ${transparencies.darkJungle5}`,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: transparencies.white90,
                    }}
                />
            )}
            <CloseButtonWrapper>
                <Tag text={isHq ? 'HQ' : isCoach ? 'Coach' : 'Member'} />
            </CloseButtonWrapper>
            <div
                style={{ position: 'relative', width: '100%', height: '100%' }}
            >
                <Bumper $minHeight={spacing.small} />
                <HorizontalFlexWrapper
                    $isVerticalOnMobile
                    $isJustifyContentCenter
                >
                    <Fonts.Medium
                        $isOpenSansSemiBold
                        style={{ textShadow: '0 0 4px white, 0 0 4px white' }}
                    >
                        {fullName}
                    </Fonts.Medium>
                </HorizontalFlexWrapper>
                <Bumper $minHeight={spacing.xxSmall} />
                <HorizontalFlexWrapper $isJustifyContentCenter>
                    <Fonts.Small
                        $textAlign="center"
                        style={{ textShadow: '0 0 4px white, 0 0 4px white' }}
                    >
                        {headline}
                    </Fonts.Small>
                </HorizontalFlexWrapper>
                {isPublished ? (
                    <>
                        <Bumper $minHeight={spacing.xSmall} />
                        <HorizontalFlexWrapper $isJustifyContentCenter>
                            <Button
                                onClick={onOpenProfileDetails}
                                $isStretch={false}
                                $isSmall
                            >{`See Profile`}</Button>
                        </HorizontalFlexWrapper>
                    </>
                ) : null}
            </div>
        </Card>
    );
};
